// angular
import { Component } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'pwj-product-details-skeleton',
  standalone: true,
  imports: [NgxSkeletonLoaderModule],
  templateUrl: './product-details-skeleton.component.html',
  styleUrl: './product-details-skeleton.component.scss',
})
export class ProductDetailsSkeletonComponent {
  readonly propertySkeletonItems = [0, 1, 2];
}
